export const TransactionConstants = {
  TRANSACTION_CREATE_START: "PORTFOLIO_CREATE_START",
  TRANSACTION_CREATE_SUCCESS: "PORTFOLIO_CREATE_SUCCESS",
  TRANSACTION_CREATE_FAILED: "PORTFOLIO_CREATE_FAILED",

  TRANSACTION_DELETE_START: "TRANSACTION_DELETE_START",
  TRANSACTION_DELETE_SUCCESS: "TRANSACTION_DELETE_SUCCESS",
  TRANSACTION_DELETE_FAILED: "TRANSACTION_DELETE_FAILED",
};
